import React, { useEffect, useRef, useState } from 'react';
import './Header.scss';
import Lottie from "lottie-react";
import { Music } from '../lottie/music'
import SearchBox from './SearchBox';
import useScrollClass from './useScrollClass';
import SparkleImageButton from './SparkleImageButton';
import { ContentCarrier } from 'models';
import { MediaCategory } from './interfaces';
import { random_icons } from './random_icons';
import { usePlaywatchKids } from './Context';
import useScrollBeyondThreshold from './useScrollBeyondThreshold';
import SearchIcon from '@mui/icons-material/Search';
import { setProfileImage } from 'features/application/application-slice';
import ColorToggleImage from './ColorToggleImage';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ProfileSection from 'layout/NetflixLayout/Header/ProfileSection';
import ProfileMenuPopper from './ProfileMenuPopper';
import { OutsideAlerter } from 'components/utility';
import ProfileContentSection from './ProfileContentSection';
export default function PlaywatchHeader({ contentCarrier }: {
    contentCarrier: ContentCarrier
}) {
    const scrolled_class = useScrollClass('', 'scrolled');
    const [profileImage, setProfileImage] = useState('');
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [popperOpen, setPopperOpen] = useState(false);
    const [categories, setCategories] = useState<MediaCategory[]>([]);
    const {
        setSearchFocused,
        searchFocused,
        focusFunc,
        selectedMedia,
        setSelectedMedia,
        selectedCategory,
        clearMedia,
        setSelectedCategory,
        search
    } = usePlaywatchKids();
    const isBeyond = useScrollBeyondThreshold(190)
    const watching = !!selectedMedia;
    useEffect(() => {
        // Use a query selector to find the element you want to use as an anchor
        const element = document.querySelector('.popper-hook');
        if (element) {
            setAnchorEl(element as HTMLElement);
        }
    }, []);

    //Temporary
    useEffect(() => {
        let temp = getIndexBasedOnHash(random_icons, `${new Date().getUTCHours()}`);
        setProfileImage(random_icons[temp]);
    }, []);

    useEffect(() => {
        if (contentCarrier) {
            const { media } = contentCarrier;
            if (media) {
                const { categories }: { categories: MediaCategory[] } = media;
                setCategories(categories);
            }
        }
    }, [contentCarrier])
    function handleSearch(term) {
        if (search) {
            search(term)
        }
    }

    return (
        <div className={`layout-header header ${scrolled_class} ${watching ? 'watching' : ''}`}>
            {!selectedMedia?.id ? null : <div className="to-scale header-profile back-button" onClick={() => {
                clearMedia()
            }}>
                <div className='header-button-inner-container'>
                    <ArrowBackIcon sx={{ color: '#000000' }} fontSize='large' style={{ height: '2em', width: '2em' }} />
                </div>
            </div>}
            <div className="to-scale header-profile">
                <div className='header-button-inner-container' onClick={() => {
                    setPopperOpen(true);
                }}>
                    <ColorToggleImage src={profileImage} startColorized={true} />
                </div>
                <ProfileMenuPopper anchorEl={anchorEl} open={popperOpen} onClose={() => {
                    setPopperOpen(false);
                }}>
                    <OutsideAlerter handler={() => {
                        if (popperOpen)
                            setPopperOpen(false);
                    }}>
                        <ProfileContentSection />
                    </OutsideAlerter>
                </ProfileMenuPopper>
            </div>
            <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div className={`header-search-container ${watching && !searchFocused ? 'search-watching' : ''}
                ${!watching && isBeyond && !searchFocused ? 'search-shrink' : ''}`}>
                    <SearchBox onSearch={handleSearch} onFocusChange={(focused) => {
                        setSearchFocused(focused)
                    }} />
                </div>
                <div className={`header-category-container  ${watching && searchFocused ? 'header-watching' : ''}
                 ${!watching && isBeyond && searchFocused ? 'header-shrink' : ''}`}>
                    <div className={`header-categories`} style={{ paddingTop: 10 }}>
                        {categories.map((category) => {
                            let temp = getIndexBasedOnHash(random_icons, `${category.name}${new Date().getUTCHours()}`);
                            return <div>
                                <SparkleImageButton
                                    on={selectedCategory === category.listId}
                                    onClick={() => {
                                        setSelectedCategory(category.listId)
                                    }}
                                    src={random_icons[temp]} />
                                <div style={{ height: 33, position: 'relative' }}>
                                    <div style={{ position: 'absolute' }}>
                                        <div className={'category-name'} style={{
                                            left: 'calc(-50% + 37px)'
                                        }}>{selectedCategory === category.listId ? category?.name : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
            <div className={`header-search-button-container ${(watching && !searchFocused) || (isBeyond && !searchFocused) ? 'search-button-show' : ''}`}>
                <div
                    className="search-icon-button"
                    onClick={() => {
                        if (focusFunc) {
                            focusFunc(true)
                        }
                    }}>
                    <div>
                        <button type="submit" className="search-button">
                            <SearchIcon className='search-icon' fontSize='large' />
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
};


function simpleHash(str: string): number {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Convert to 32bit integer
    }

    return hash;
}

export function getIndexBasedOnHash(arr: any[], str: string): number {
    const hash = simpleHash(str);
    // Use the absolute value of the hash to ensure a positive index
    // Use modulo to ensure the index is within the bounds of the array
    return Math.abs(hash) % arr.length;
}

